import {useDispatch, useSelector} from "react-redux";
import {getRiverFloodConstructorRights} from "../../Privileges/PrivilegesSelectors";
import {selectorStationsForFilters} from "../periodValuesFilterApi";
import React from "react";
import {findFirstByName} from "../common/matchMethods";
import {getDatasourceTypesByStation} from "../decadeConstructor/ApiCalls";
import {deleteFilter,} from "../riverFlood/riverFloodSlice";
import {
  Autocomplete,
  Button,
  FilterRemoveIcon,
  Heading,
  IconButton,
  Pane,
  SelectField,
  TextInputField,
  Tooltip
} from "evergreen-ui";
import CreateTemplateDialog from "../common/CreateTemplateDialog";
import EvaporationTable from "./EvaporationTable";
import EvaporationFilterPanel from "./filter/EvaporationFilterPanel";
import {evaporationObject} from "./model/EvaporationModels";
import {
  selectStation,
  selectStationEntity,
  selectWaterTempDatasourceType,
  selectWaterTempMeteoCode,
  selectWindSpeedDatasourceType,
  selectWindSpeedMeteoCode,
  setNewEvaporationConstructor
} from "./evaporationSlice";
import CreateOutputFormEvaporationDialog from "./CreateOutputFormEvaporationDialog";
import {saveEvapTemplate} from "./api/ApiCalls";
import {createFullStationName, createFullStationNameWithOuterIdx} from "../Constructor.DefaultPage";
import {AutoCompleteConstructor} from "../../BaseConstructor/BaseConstructor";

export default function EvaporationPage({isFullInfo, isEdit}) {
  const dispatch = useDispatch();
  const privileges = useSelector(state => state.login.privileges)

  //todo: потом заменить
  const rights = getRiverFloodConstructorRights(privileges)

  const stations = useSelector(selectorStationsForFilters);


  const [isFormShown, setIsShown] = React.useState(false)
  const evapConstructor = useSelector(state => state.evaporationConstructor)
  const [createTemplateShown, setCreateTemplateShown] = React.useState(false)
  const setCreateTemplateShownCallback = (shown) => setCreateTemplateShown(shown)

  const setIsShownCallback = (shown) => setIsShown(shown)

  const [dsourceTypes, setDsourceTypes] = React.useState([]);
  const [stationEntity, setStationEntity] = React.useState(getEntitiesIfSet());
  const [entityLoading, setEntityLoading] = React.useState(stationEntity.length === 0 && (isFullInfo || isEdit))
  const [typesLoading, setTypesLoading] = React.useState(dsourceTypes.length === 0 && (isFullInfo || isEdit))

  const [idx, setIdx] = React.useState(chooseIdx())

  const smthIsLoading = typesLoading || entityLoading

  function chooseIdx() {
    for (let i = 0; i < stations.length; i++) {
      if (stations[i].name === evapConstructor.station.name)
        return stations[i].idx
    }
    return undefined
  }

  function getEntitiesIfSet() {
    if (evapConstructor.stationEntity === undefined) return []
    if (stations.length === 0) return []
    if (isFullInfo === undefined) return []
    if (isFullInfo === true) return []
    if (isEdit === undefined) return []
    if (isEdit === true) return []
    if (evapConstructor.station.name === '') return []
    let res = findFirstByName(stations, evapConstructor.station.name)

    return  res.stationEntities;
  }

  if (entityLoading) {
    let res = findFirstByName(stations, evapConstructor.station.name)

    setStationEntity(res.stationEntities);
    setEntityLoading(false)
    getDatasourceTypesByStation(res.id).then((result) => {
      setDsourceTypes(result.data)
      setTypesLoading(false)
    })
  }

  function isCreateTemplateDisabled() {
    let constrIsUndef = evapConstructor.station.id === -1
    let entityIsUndef = evapConstructor.stationEntity.id === -1
    return constrIsUndef || entityIsUndef
  }

  function isOutputFormDisabled() {
    return isCreateTemplateDisabled()
  }

  function onSelectStation(selectedItem) {
    clearFilter()
    setIdx(
        selectedItem.split("] ")[0]
            .replace("[", "")
    )
    selectedItem = selectedItem.split("] ")[1]
    let res = findFirstByName(stations, selectedItem)

    setStationEntity(res.stationEntities);
    getDatasourceTypesByStation(res.id).then((result) => {
      setDsourceTypes(result.data)
      res = {id: res.id, name: res.name, sourcesTypes: result.data}
      dispatch(selectStation(res));
    })
  }

  function onSelectStationEntity(selectedItem) {
    let res = findFirstByName(stationEntity, selectedItem)
    dispatch(selectStationEntity(res));
  }

  function clearFilter() {
    dispatch(setNewEvaporationConstructor({...evaporationObject}))
  }

  if (smthIsLoading) {
    return <></>
  }

  return (
      <Pane display="block" marginBottom={80}>
        <Heading size={600}>Конструктор "Наблюдение испарения"</Heading>

        <Pane width={1} display="flex" columnGap={10} marginBottom={20} marginTop={5}>
          <Pane>
            <Pane marginBottom={5}>
              Станция
            </Pane>

            {AutoCompleteConstructor(
                onSelectStation,
                evapConstructor,
                idx,
                stations,
                isFullInfo,
                createFullStationNameWithOuterIdx,
                createFullStationName
            )}
          </Pane>
          <Pane>
            <SelectField
                label={"Пункт наблюдения"}
                width={290}
                onChange={e => onSelectStationEntity(e.target.value)}
                value={typeof evapConstructor.stationEntity.name === 'string' ? evapConstructor.stationEntity.name : "dswhg"}
                disabled={evapConstructor.station.id === -1 || isFullInfo}
            >
              <option value={-1}>Выберите пункт наблюдения</option>
              {stationEntity.filter((ent) => ent.typeCode !== "DEVICE")
                  .map((type) => <option key={type.name} value={type.name}>{type.name}</option>)}
            </SelectField>
          </Pane>
        </Pane>

        <EvaporationFilterPanel constructor={evapConstructor}
                                isFullInfo={isFullInfo}
                                possibleDatasourceTypes={dsourceTypes}
                                onDeleteFilter={deleteFilter}
                                onSelectDatasourceTypeForRainfall={selectWaterTempDatasourceType}
                                onSelectDatasourceTypeForLevel={selectWindSpeedDatasourceType}
                                onSelectCodeForWaterTemp={selectWaterTempMeteoCode}
                                onSelectCodeForWindSpeed={selectWindSpeedMeteoCode}
                                stations={stations}
        />

        {
          !isFullInfo && !isEdit ?
              <Pane>
                {
                  rights.canSaveTemplate ?
                      isCreateTemplateDisabled() ?
                          <Tooltip content={"Выберите фильтры"}>
                            <Pane display={"inline"}>
                              <Button marginRight={10}
                                      marginTop={10}
                                      disabled={true}>Сохранить шаблон</Button>
                            </Pane>
                          </Tooltip> :
                          <Button marginRight={10}
                                  marginTop={10}
                                  onClick={() => {
                                    setCreateTemplateShown(true)
                                  }}
                                  disabled={false}>Сохранить шаблон</Button>

                      : <></>
                }
                {
                  rights.canCreateOutputForm ?
                      isOutputFormDisabled() ?
                          <Tooltip content={"Выберите фильтры"}>
                            <Pane display={"inline"}>
                              <Button disabled={true} marginTop={10}>Выгрузить выходную форму</Button>
                            </Pane>
                          </Tooltip> :
                          <Button onClick={() => {
                            setIsShown(true);
                          }}
                                  disabled={false}
                                  marginTop={10}>Выгрузить выходную форму</Button>
                      : <></>
                }
                <Tooltip content="Сбросить">
                  <IconButton marginTop={10} marginLeft={10} icon={FilterRemoveIcon} onClick={() => clearFilter()}/>
                </Tooltip>

              </Pane> : <></>

        }


        {
          !isFullInfo && !isEdit ? <>
            <EvaporationTable/>
          </> : <></>
        }


        <CreateOutputFormEvaporationDialog
            constructor={evapConstructor}
            isShown={isFormShown}
            setIsShown={setIsShownCallback}
            viaTemplateId={false}
            name={""}
        />


        <CreateTemplateDialog isShown={createTemplateShown}
            setIsShown={setCreateTemplateShownCallback}
            createTemplate={(templateName) => saveEvapTemplate(evapConstructor, templateName)}
        />


      </Pane>
  )

}